import { baseUrl } from '../utils/utils';

export class PluginService {
    async forceLoadPlugin(pluginPath: string) {
        const originalBaseUrl = baseUrl();
        const cleanBaseUrl = originalBaseUrl.endsWith('/')
            ? originalBaseUrl.substring(0, originalBaseUrl.length - 1)
            : originalBaseUrl;
        const cleanPluginPath = pluginPath.startsWith('/')
            ? pluginPath.substring(1)
            : pluginPath;
        const pluginUrl = `${cleanBaseUrl}/${cleanPluginPath}`;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = pluginUrl;
        document.querySelector('body').appendChild(script);

        script.onload = () => {
            console.info(`Plugin with url ${pluginUrl} was loaded.`);
        };

        script.onerror = () => {
            console.error(`Could not load plugin with url ${pluginUrl}. Please check the relative path to the script.`);
        };
    }
}
